export const SET_INPUT_VALUE = 'SET_INPUT_VALUE';

export const RESET_ALL_VALUES = 'RESET_ALL_VALUES';

export const PUT_ERRORS = 'PUT_ERRORS';

export const SET_FORM_LOADING = 'SET_FORM_LOADING';

export const SET_FORM_STATE = 'SET_FORM_STATE';
